import { render, staticRenderFns } from "./BlockUI.vue?vue&type=template&id=b4880b7c&scoped=true&"
import script from "./BlockUI.vue?vue&type=script&lang=js&"
export * from "./BlockUI.vue?vue&type=script&lang=js&"
import style0 from "./BlockUI.vue?vue&type=style&index=0&id=b4880b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4880b7c",
  null
  
)

export default component.exports